export const extractCountryCode = (mobileNumber: string) => {
  if (!mobileNumber || !mobileNumber.length) {
    return {
      countryCode: '',
      mobileNumber,
    };
  } else if (mobileNumber.length === 8) {
    return {
      countryCode: '852',
      mobileNumber,
    };
  } else if (mobileNumber.length === 9 && mobileNumber.startsWith('9')) {
    return {
      countryCode: '886',
      mobileNumber,
    };
  } else if (mobileNumber.length === 10 && mobileNumber.startsWith('09')) {
    return {
      countryCode: '886',
      mobileNumber: mobileNumber.slice(1),
    };
  } else if (mobileNumber.length === 11 && mobileNumber.startsWith('852')) {
    return {
      countryCode: '852',
      mobileNumber: mobileNumber.slice(3),
    };
  } else if (mobileNumber.length === 11 && mobileNumber.startsWith('853')) {
    return {
      countryCode: '853',
      mobileNumber: mobileNumber.slice(3),
    };
  } else if (mobileNumber.length === 11 && mobileNumber.startsWith('1')) {
    return {
      countryCode: '86',
      mobileNumber,
    };
  } else if (mobileNumber.length === 12 && mobileNumber.startsWith('886')) {
    return {
      countryCode: '886',
      mobileNumber: mobileNumber.slice(3),
    };
  } else if (mobileNumber.length === 13 && mobileNumber.startsWith('86')) {
    return {
      countryCode: '86',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // Singapore (65) - 65 + 8 digits
  else if (mobileNumber.length === 10 && mobileNumber.startsWith('65')) {
    return {
      countryCode: '65',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // Australia (61) - 61 + 9-10 digits
  else if (
    (mobileNumber.length === 11 || mobileNumber.length === 12) &&
    mobileNumber.startsWith('61')
  ) {
    return {
      countryCode: '61',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // Malaysia (60) - 60 + 10-11 digits
  else if (
    (mobileNumber.length === 12 || mobileNumber.length === 13) &&
    mobileNumber.startsWith('60')
  ) {
    return {
      countryCode: '60',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // Netherlands (31) - 31 + 9-10 digits
  else if (
    (mobileNumber.length === 11 || mobileNumber.length === 12) &&
    mobileNumber.startsWith('31')
  ) {
    return {
      countryCode: '31',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // South Africa (27) - 27 + 9-10 digits
  else if (
    (mobileNumber.length === 11 || mobileNumber.length === 12) &&
    mobileNumber.startsWith('27')
  ) {
    return {
      countryCode: '27',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // South Korea (82) - 82 + 9-11 digits
  else if (
    mobileNumber.length >= 11 &&
    mobileNumber.length <= 13 &&
    mobileNumber.startsWith('82')
  ) {
    return {
      countryCode: '82',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // Switzerland (41) - 41 + 9-10 digits
  else if (
    (mobileNumber.length === 11 || mobileNumber.length === 12) &&
    mobileNumber.startsWith('41')
  ) {
    return {
      countryCode: '41',
      mobileNumber: mobileNumber.slice(2),
    };
  }
  // United Kingdom (44) - 44 + 9-11 digits
  else if (
    mobileNumber.length >= 11 &&
    mobileNumber.length <= 13 &&
    mobileNumber.startsWith('44')
  ) {
    return {
      countryCode: '44',
      mobileNumber: mobileNumber.slice(2),
    };
  }

  return {
    countryCode: '',
    mobileNumber,
  };
};

export const validateMobileNumber = (
  mobileNumber: string,
  countryCode: string,
) => {
  if (!mobileNumber || !countryCode) return false;

  switch (countryCode) {
    // Hong Kong (852): 8 digits, starts with 4-9
    case '852':
      return /^[4-9]\d{7}$/.test(mobileNumber);
    // China (86): starts with 1, 130-199 prefix, length 11 (or 13 for 140-144 prefix)
    case '86': {
      const first3 = Number(mobileNumber.substring(0, 3));
      if (first3 < 130 || first3 > 199) return false;
      if (first3 >= 140 && first3 <= 144) return mobileNumber.length === 13;
      return mobileNumber.length === 11;
    }
    // Macau (853): 8 digits, starts with 6
    case '853':
      return /^6\d{7}$/.test(mobileNumber);
    // Taiwan (886): 9 digits starting with 9, or 10 digits starting with 09
    case '886':
      return /^(9\d{8}|09\d{8})$/.test(mobileNumber);
    // Singapore (65): 8 digits
    case '65':
      return /^\d{8}$/.test(mobileNumber);
    // Australia (61): 9-10 digits
    case '61':
      return /^\d{9,10}$/.test(mobileNumber);
    // Malaysia (60): 10-11 digits
    case '60':
      return /^\d{10,11}$/.test(mobileNumber);
    // Netherlands (31): 9-10 digits
    case '31':
      return /^\d{9,10}$/.test(mobileNumber);
    // South Africa (27): 9-10 digits
    case '27':
      return /^\d{9,10}$/.test(mobileNumber);
    // South Korea (82): 9-11 digits
    case '82':
      return /^\d{9,11}$/.test(mobileNumber);
    // Switzerland (41): 9-10 digits
    case '41':
      return /^\d{9,10}$/.test(mobileNumber);
    // United Kingdom (44): 9-11 digits
    case '44':
      return /^\d{9,11}$/.test(mobileNumber);
    default:
      return false;
  }
};
